import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';

const style = {
  card: {
    marginBottom: 20,
    paddingBottom: 0
  },
  typography: {
    paddingBottom: 5
  }
};

export default props => (
  <Card style={style.card} color="secondary">
    <CardHeader title={props.title} subheader="total" />
    <Typography variant="title" align="center" style={style.typography}>
      {props.value ? props.value : 0}
    </Typography>
  </Card>
);



// WEBPACK FOOTER //
// ./src/common/CountCard.js